<script lang="ts">
import type { SvelteComponent } from 'svelte'
	import { createEventDispatcher } from 'svelte'
	import type { IconSource } from 'svelte-hero-icons'
	import { Icon } from 'svelte-hero-icons'

	import { goto } from '$app/navigation'
    import { UserActionEnabledSync } from '$lib/stores/user/manager'
	import { user_store } from '$lib/stores/user/user'

	import NewItemIcon from './Icons/NewItemIcon.svelte'

	const dispatch = createEventDispatcher()

	export let id = ''
	export let iconComponent: typeof SvelteComponent | undefined = undefined
	export let iconSource: IconSource | undefined = undefined
	export let icon = ''
	export let iconClass = ''
	export let iconSolid = false
	export let text = ''
	export let action = ''
	export let target = '_self'
	export let permission = ''

	export let isSelected = false
	export let isNew = false
	export let newIconPos: 'left' | 'right' | 'inline' = 'right'

	let myId = id !== '' ? id : text
	let hasAction = action !== ''

	$: newItemIconClass = newIconPos === 'left' ? 'newItem-Left' : newIconPos === 'right' ? 'newItem-Right' : 'newItem-Inline'

	$: display = UserActionEnabledSync(permission, $user_store)

	function hasIcon() {
		if (iconComponent === undefined && iconSource === undefined && icon === '') return false
		return true
	}
	function doAction(event: Event) {
		// console.log('MenuSubItem-doAction', event);

		//--- Check if the target is on another window
		if (target === '_self') {
			//--- Cancel the propagation of the Event, since it handles it here
			event.preventDefault()

			// Check if you have any action set,
			// otherwise fire the Event
			if (hasAction) {
				goto(action)
			} else {
				dispatch('click', myId)
			}
		}
	}
</script>

{#if display}

	<a href={action} {target} on:click={(e) => doAction(e)} {...$$restProps}>
		<div class="menu-subitem" class:menu-subitem-selected={isSelected}>
			{#if isNew}
				<span class={newItemIconClass}><NewItemIcon /></span>
			{/if}
			<div class="menu-subitem-row mx-2.5">
				<div class="menu-subitem-row-group inline-block align-middle">
					{#if hasIcon()}
						<div class="menu-subitem-icon">
							{#if iconComponent !== undefined}
								<svelte:component this={iconComponent} class={iconClass} />
							{:else if iconSource !== undefined}
								<Icon src={iconSource} solid={iconSolid} class="flex-shrink-0 w-5 h-5 {iconClass}" />
							{:else}
								<img src="/menu/{icon}" alt={text} class={iconClass} />
							{/if}
						</div>
					{/if}
					<div class="menu-subitem-text">{text}</div>
				</div>
			</div>
		</div>
	</a>
{/if}

<style lang="postcss">
	/*
	.newItem
	{
		@apply relative top-[-5px];
		@apply left-36;
	}
	*/
	.newItem-Left {
		@apply inline-block fixed;
		/* mt-[-4px]; */
		left: 48px !important;
	}
	.newItem-Right {
		/* @apply inline-block fixed mt-3; */
		@apply inline-block fixed;
		/* mt-[-4px]; */
		right: 20px !important;
	}
	.newItem-Inline {
		@apply inline-block fixed mt-[18px];
		right: 20px !important;
	}	
	.menu-subitem-row {
		@apply relative h-12;
	}
	.menu-subitem-row-group {
		/* @apply mt-2.5; */
	}
	.menu-subitem-icon {
		@apply inline-block fixed w-5 h-5;
		/* @apply left-4; */
		@apply left-6;
	}
	.menu-subitem-text {
		@apply inline-block fixed;
		/* @apply left-14; */
		left: 64px;
	}

	.menu-subitem {
		/* @apply mt-px; */
		@apply text-white;
		@apply flex cursor-pointer;
		background: #474747;
	}
	.menu-subitem:hover {
		@apply bg-gray-700;
	}
	.menu-subitem-selected {
		@apply bg-gray-600 text-emerald-200 font-medium flex cursor-pointer;
	}
</style>
